import _slicedToArray from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// packages/react/use-controllable-state/src/useControllableState.tsx
import * as React from "react";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
function useControllableState(_ref) {
  var prop = _ref.prop,
    defaultProp = _ref.defaultProp,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
  var _useUncontrolledState = useUncontrolledState({
      defaultProp: defaultProp,
      onChange: onChange
    }),
    _useUncontrolledState2 = _slicedToArray(_useUncontrolledState, 2),
    uncontrolledProp = _useUncontrolledState2[0],
    setUncontrolledProp = _useUncontrolledState2[1];
  var isControlled = prop !== void 0;
  var value = isControlled ? prop : uncontrolledProp;
  var handleChange = useCallbackRef(onChange);
  var setValue = React.useCallback(function (nextValue) {
    if (isControlled) {
      var setter = nextValue;
      var value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
      if (value2 !== prop) handleChange(value2);
    } else {
      setUncontrolledProp(nextValue);
    }
  }, [isControlled, prop, setUncontrolledProp, handleChange]);
  return [value, setValue];
}
function useUncontrolledState(_ref2) {
  var defaultProp = _ref2.defaultProp,
    onChange = _ref2.onChange;
  var uncontrolledState = React.useState(defaultProp);
  var _uncontrolledState = _slicedToArray(uncontrolledState, 1),
    value = _uncontrolledState[0];
  var prevValueRef = React.useRef(value);
  var handleChange = useCallbackRef(onChange);
  React.useEffect(function () {
    if (prevValueRef.current !== value) {
      handleChange(value);
      prevValueRef.current = value;
    }
  }, [value, prevValueRef, handleChange]);
  return uncontrolledState;
}
export { useControllableState };